<template>
  <div :class="'grammar-theme-' + theme">
    <div v-if="entity.title">{{entity.title}}</div>
  </div>
</template>

<script>
export default {
  name: 'GraphicPreview',
  props: {
    entity: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: String,
      default: 'card'
    }
  },
  data () {
    return {}
  },
  created() {
    
  }
}
</script>
